export default "__VITE_ASSET__Brv7o0_4__"